import React, { useEffect } from 'react';

const RequestSubmissionForm = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: RequestSubmissionForm is not implemented yet.');
  }, []);
  return (
    <>
  { /*RequestSubmissionForm */} 
 </>
  );
};

export default RequestSubmissionForm;
